import { createSelector } from 'reselect'
import { AI_CHAT, IS_NEW_CONVERSATION } from '../../pages/ChatPage/fields'

// PLOP_APPEND_PATTERN_ANCHOR

// Get digital proposals aiSuggestion
export const aiMessageConversationIdSelector = createSelector(
  ({ tools }) => tools[AI_CHAT].conversationId,
  conversationId => conversationId
)

export const isNewChatModeSelector = createSelector(
  ({ tools }) => tools[AI_CHAT].isNewChatMode,
  isNewChatMode => isNewChatMode
)

export const aiConversationIsLoadingSelector = id => {
  return createSelector(
    ({ tools }) => tools.aiConversations.byId[id]?.isLoading,
    isLoading => isLoading
  )
}

// Get ai conversations
export const getAiConversationsSelector = createSelector(
  ({ tools }) => tools.aiConversations.byId,
  ({ tools }) => tools.aiConversations.allIds,
  (byId, allIds) => allIds.map(id => byId[id]).filter(conversation => conversation && conversation.is_active !== false)
)

// Get a specific conversation by ID
export const getAiConversationByIdSelector = id =>
  createSelector(
    ({ tools }) => tools.aiConversations.byId[id],
    conversation => conversation
  )

export const isNewConversationSelector = id => {
  return createSelector(
    ({ tools }) => tools.aiConversations.byId[id]?.[IS_NEW_CONVERSATION],
    isNewConversation => isNewConversation
  )
}

// Get request_id by conversation ID
export const getRequestIdByConversationIdSelector = id =>
  createSelector(
    ({ tools }) => tools.aiConversations.byId[id]?.request_id,
    requestId => requestId
  )

export const getAiConversationsIsLoadingSelector = createSelector(
  ({ tools }) => tools.aiConversations.isLoading,
  isLoading => isLoading
)

export const getAiConversationsWasLoadedSelector = createSelector(
  ({ tools }) => tools.aiConversations.wasLoaded,
  wasLoaded => wasLoaded
)

export const getAiConversationsNextSelector = createSelector(
  ({ tools }) => tools.aiConversations.paging.next,
  next => next
)

export const getAiConversationMessagesIsLoadingSelector = conversationId => {
  return createSelector(
    ({ tools }) => tools.aiConversations.byId[conversationId]?.messages?.isLoading,
    isLoading => isLoading
  )
}

export const getAiConversationMessagesWasLoadedSelector = conversationId => {
  return createSelector(
    ({ tools }) => tools.aiConversations.byId[conversationId]?.messages?.wasLoaded,
    wasLoaded => wasLoaded
  )
}

export const getAiConversationMessagesNextSelector = conversationId => {
  return createSelector(
    ({ tools }) => tools.aiConversations.byId[conversationId]?.messages?.paging.next,
    next => next
  )
}

// Get sponsor form industry suggestions
export const sponsorFormIndustrySuggestionsSelector = createSelector(
  ({ tools }) => tools.sponsorFormIndustrySuggestions.results,
  // make sure we always return an array to avoid crashes (AI may return different structure)
  results => (Array.isArray(results) ? results : [])
)

export const getSponsorFormIndustrySuggestionsIsLoadingSelector = createSelector(
  ({ tools }) => tools.sponsorFormIndustrySuggestions.isLoading,
  isLoading => isLoading
)

export const getSponsorFormIndustrySuggestionsErrorSelector = createSelector(
  ({ tools }) => tools.sponsorFormIndustrySuggestions.error,
  error => error
)

export const sponsorFormIndustrySuggestionsWasLoadedSelector = createSelector(
  ({ tools }) => tools.sponsorFormIndustrySuggestions.wasLoaded,
  wasLoaded => wasLoaded
)

// Get updates history
export const getChangeHistorySelector = createSelector(
  ({ tools }) => tools.changeHistory.results,
  results => results
)

export const getChangeHistoryIsLoadingSelector = createSelector(
  ({ tools }) => tools.changeHistory.isLoading,
  isLoading => isLoading
)

export const getChangeHistoryErrorSelector = createSelector(
  ({ tools }) => tools.changeHistory.error,
  error => error
)

export const getChangeHistoryNextSelector = createSelector(
  ({ tools }) => tools.changeHistory.paging.next,
  next => next
)
export const getChangeHistoryWasLoadedSelector = createSelector(
  ({ tools }) => tools.changeHistory.wasLoaded,
  wasLoaded => wasLoaded
)

export const selectorsListSelector = createSelector(
  ({ tools }) => tools.selectors.results,
  info => info
)

export const getSelectorsIsLoadingSelector = createSelector(
  ({ tools }) => tools.selectors.isLoading,
  isLoading => isLoading
)

export const getSelectorsWasLoadedSelector = createSelector(
  ({ tools }) => tools.selectors.wasLoaded,
  wasLoaded => wasLoaded
)
export const getSelectorsErrorSelector = createSelector(
  ({ tools }) => tools.selectors.error,
  error => error
)

export const updatedSelectorIsLoadingSelector = createSelector(
  ({ tools }) => tools.updatedSelector.isLoading,
  isLoading => isLoading
)

export const selectorWasUpdatedSelector = createSelector(
  ({ tools }) => tools.updatedSelector.wasUpdated,
  wasUpdated => wasUpdated
)
export const updatedSelectorErrorSelector = createSelector(
  ({ tools }) => tools.updatedSelector.error,
  error => error
)

// Update ai conversation
export const updateAiConversationSelector = createSelector(
  ({ tools }) => tools.updateAiConversation.data,
  data => data
)

export const updateAiConversationIsLoadingSelector = createSelector(
  ({ tools }) => tools.updateAiConversation.ids,
  ids => Object.keys(ids || {}).length > 0
)

export const isCurrentChatItemUpdatingSelector = id => {
  return createSelector(
    ({ tools }) => tools.updateAiConversation.ids,
    ids => Boolean(ids[id])
  )
}

export const updateAiConversationErrorSelector = createSelector(
  ({ tools }) => tools.updateAiConversation.error,
  error => error
)

export const updateAiConversationWasUpdatedSelector = createSelector(
  ({ tools }) => tools.updateAiConversation.wasUpdated,
  wasUpdated => wasUpdated
)
